<template>
  <div>
    <a href="https://anyword.now.sh/" class="mb-3">Go Back</a>
    <h3>404 Not Found</h3>
    <p>
      The page you are looking for are missing or under maintenance
    </p>
  </div>
</template>

<style scoped>
</style>

<script>
export default {

};
</script>
